
export default () => typeof window === 'object';
